import ApiBase from './api-base'
import Ajax from '../common/ajax'
import store from '../store'

export default {
  ...ApiBase,
  model: 'vip',
  sendVcode (data = {}) {
    return Ajax.post(`/api/gradeExaminee/v1/${this.model}/authcode`, data)
  },
  sendEmailcode (data = {}) {
    return Ajax.post(`/api/gradeExaminee/v1/${this.model}/authCodeEmail`, data)
  },
  login (data) {
    return Ajax.post(`/api/gradeExaminee/v1/${this.model}/login`, data)
  },
  register (data = {}) {
    return Ajax.post(`/api/gradeExaminee/v1/${this.model}/register`, data)
  },
  registerEmail (data = {}) {
    return Ajax.post(`/api/gradeExaminee/v1/${this.model}/overseasRegister`, data)
  },
  getVipdetail (data = {}) {
    return Ajax.post(`/api/gradeExaminee/v1/${this.model}/detail`, data)
  },
  getagentList () {
    return Ajax.post(`/api/gradeExaminee/v1/${this.model}/agentList`)
  },
  getNationality () {
    return Ajax.get(`/api/gradeExaminee/v1/${this.model}/nationality`)
  },
  setApply (data = {}) {
    return Ajax.post(`/api/gradeExaminee/v1/${this.model}/apply`, data)
  },
  getAppInfo () {
    return Ajax.get(`/api/gradeExaminee/v1/${this.model}/getHomeConfig`)
  },
  getQuery () {
    return Ajax.post(`/api/gradeExaminee/v1/${this.model}/result`)
  },
  getIsIDNoRepeat (data = {}) {
    return Ajax.post(`/api/gradeExaminee/v1/${this.model}/isIDNoRepeat`, data)
  },
}
